"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexColumn, Table } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
import { ProfilePreviewTooltipCollectionTableHeader } from "./ProfilePreviewTooltipCollectionTableHeader";
import { ProfilePreviewTooltipCollectionTableRowSkeleton } from "./ProfilePreviewTooltipCollectionTableRowSkeleton";
import { MAX_COLLECTIONS } from "./utils";
export function ProfilePreviewTooltipCollectionTableSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProfilePreviewTooltipCollectionTableHeader />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FlexColumn className="w-full overflow-hidden"><Table contentClassName="scrollbar-hidden" header={t0} itemKey={_temp} items={range(MAX_COLLECTIONS)} renderRow={ProfilePreviewTooltipCollectionTableRowSkeleton} size="xs" /></FlexColumn>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return index;
}